// Copyright (c) 2024 - Present. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import {
  CheckRounded,
  RocketLaunchRounded,
  ScienceRounded,
} from '@/constants/hardfin-standard-icons';
import { ListItemIcon, MenuItem, Stack, Typography } from '@mui/material';

interface Props {
  /**
   * The current environment name.
   */
  currentEnvironment: 'prod' | 'sandbox';
}

/**
 * A menu component that displays environment options and allows switching between them.
 */
export function EnvironmentMenu(props: Props) {
  const environments = [
    {
      name: 'prod',
      label: 'Production',
      url: 'https://assets.hardfin.com',
      icon: <RocketLaunchRounded fontSize="small" />,
    },
    {
      name: 'sandbox',
      label: 'Sandbox',
      url: 'https://sandbox.hardfin.com',
      icon: <ScienceRounded fontSize="small" />,
    },
  ];

  return (
    <>
      {environments.map((env) => (
        <MenuItem
          key={env.name}
          {...(props.currentEnvironment !== env.name && {
            component: 'a',
            href: env.url,
          })}
          sx={{
            paddingX: 1,
            marginX: 1,
            borderRadius: 1,
            cursor:
              props.currentEnvironment === env.name ? 'default' : 'pointer',
          }}
        >
          <ListItemIcon>{env.icon}</ListItemIcon>
          <Stack direction="row" spacing={1} width="100%">
            <Typography variant="body2">{env.label}</Typography>
            {props.currentEnvironment === env.name && (
              <CheckRounded fontSize="small" sx={{ marginLeft: 'auto' }} />
            )}
          </Stack>
        </MenuItem>
      ))}
    </>
  );
}
